import { defineMessages } from "react-intl";

const messages = defineMessages({
    a1_h3: {
        id: "memory.landing.features.a1.h3",
    },
    a2_h3: {
        id: "memory.landing.features.a2.h3",
    },
    a3_h3: {
        id: "memory.landing.features.a3.h3",
    },
    a1_d: {
        id: "memory.landing.features.a1.d",
    },
    a2_d: {
        id: "memory.landing.features.a2.d",
    },
    a3_d: {
        id: "memory.landing.features.a3.d",
    },
    a3_s: {
        id: "memory.landing.features.a3.s",
    },
    join: {
        id: "memory.landing.features.join",
    },
    start: {
        id: "landing.start",
    },
});

export default messages;
